<!--
/**
 * peacohrm is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 peacohrm Inc., http://www.peacohrm.com
 *
 * peacohrm is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * peacohrm is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */
 -->

<template>
  <oxd-dialog
    :style="{width: '90%', maxWidth: '450px'}"
    @update:show="onCancel"
  >
    <div class="peacohrm-modal-header">
      <oxd-text tag="h6" class="peacohrm-main-title"> Share Vacancy </oxd-text>
    </div>
    <oxd-divider />
    <div v-if="isLoading" class="peacohrm-loader">
      <oxd-loading-spinner />
    </div>
    <div style="display: flex; flex-direction: column; gap: 20px;">
      <div style="display: flex; flex-direction: column; gap: 16px;">
        <oxd-text tag="p" class="peacohrm-about-title">
          Share the link via
        </oxd-text>
        <div style="display: flex; gap: 16px">
          <img
              :src="facebookIcon"
              class="peacohrm-social-icon"
              @click="shareWithFacebook"
          />
          <img
              :src="linkdinIcon"
              class="peacohrm-social-icon"
              @click="shareWithLinkedin"
          />
          <img
              :src="xIcon"
              class="peacohrm-social-icon"
              @click="shareWithX"
          />
        </div>
      </div>
      <div style="display: flex; flex-direction: column; gap: 16px;">
        <oxd-text tag="p" class="peacohrm-about-title"> Or copy link </oxd-text>
        <div
          style="
            border-radius: 4px;
            padding: 12px;
            border: 1px solid #e8eaef;
            background: #fff;
            display: flex;
            justify-content: space-between;
          "
        >
          <oxd-text tag="p" class="peacohrm-about-text">
            {{ applyUrl }}
          </oxd-text>

          <button
            style="
              padding: 3px 10px;
              border-radius: 3px;
              background: #0b11d2;
              color: #fff;
              font-size: 12px;
              border: none;
              cursor: pointer;
            "
            @click="copyToClipboard"
          >
            Copy
          </button>
        </div>
      </div>
    </div>
  </oxd-dialog>
</template>

<script>
import {APIService} from '@/core/util/services/api.service';
import {OxdDialog, OxdSpinner} from '@ohrm/oxd';

export default {
  props:{
    applyUrl: String,
  },
  components: {
    'oxd-loading-spinner': OxdSpinner,
    'oxd-dialog': OxdDialog,
  },
  emits: ['close'],
  setup() {
    const facebookIcon = `${window.appGlobal.publicPath}/images/facebook.png`;
    const linkdinIcon = `${window.appGlobal.publicPath}/images/linkdin.png`;
    const xIcon = `${window.appGlobal.publicPath}/images/x.png`;
    const http = new APIService(window.appGlobal.baseUrl, '/api/v2/core/about');
    return {
      http,
      facebookIcon,
      linkdinIcon,
      xIcon
    };
  },
  data() {
    return {
      isLoading: false,
      data: null,
    };
  },
  beforeMount() {
    this.isLoading = true;
    this.http
      .getAll()
      .then((response) => {
        const {data} = response.data;
        this.data = {...data};
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  methods: {
    onCancel() {
      this.$emit('close', true);
    },
    copyToClipboard() {
      const textArea = document.createElement('textarea');
      textArea.value = this.applyUrl;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);

      this.$toast.success({
        title: this.$t('general.success'),
        message: this.$t('Copied to Clipboard'),
      });
    },
    shareWithFacebook() {
      const encodedUrl = encodeURIComponent(this.applyUrl);
      const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&quote=feeling%20awesome`;
      window.open(facebookShareUrl, '_blank');

    },
    shareWithLinkedin() {
      const encodedUrl = encodeURIComponent(this.applyUrl);
      const linkedInURL = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}&title=feeling%20awesome&summary=feeling%20awesome&source=YourSource`;
      window.open(linkedInURL, '_blank');

    },
    shareWithX() {
      const encodedUrl = encodeURIComponent(this.applyUrl);
      const twitterURL = `https://twitter.com/intent/tweet?url=${encodedUrl}`;
      window.open(twitterURL, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.peacohrm-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80px;
}
.peacohrm-about {
  grid-template-columns: 150px 1fr;
  &-title,
  &-text {
    word-break: break-word;
    font-size: $oxd-input-control-font-size;
  }
  &-title {
    font-weight: 700;
  }
  .peacohrm-social-icon {
    height: 12px;
  }
}
</style>
